<template>
  <!-- Card-based, mobile-first redesign of the TECAL form for the Corrección
       de Tests chatbot. Same single-step, server-driven flow and identical
       `answer.answers` payload as Tecal.vue (edad + p1..p101 responses) — only
       the presentation changes. Deliberate fork: ModalAutomaticTest keeps the
       original Tecal.vue. -->
  <div class="tec-root">
    <!-- ── HEADER ── -->
    <div class="tec-hdr">
      <div class="tec-hdr-row">
        <div class="tec-logo-pill">
          <div class="tec-logo-gem">👂</div>
          <span class="tec-logo-name">TECAL</span>
        </div>
        <div class="tec-hdr-spacer"></div>
        <div class="tec-hdr-step">Comprensión auditiva</div>
      </div>
      <div class="tec-prog-wrap">
        <div class="tec-prog-fill" :style="{ width: progress + '%' }"></div>
      </div>
    </div>

    <div class="tec-phase-banner">
      <span class="tec-pdot"></span>
      Marca la respuesta del niño/a · deja en blanco las correctas
    </div>

    <div class="tec-main">
      <div class="tec-instruc">
        <strong>Instrucciones:</strong> No es necesario completar las respuestas
        correctas — si dejas un ítem en blanco se autocompletará con la
        alternativa correcta. Marca solo las respuestas que el niño/a dio.
      </div>

      <!-- config: edad -->
      <div class="tec-config">
        <div class="tec-config-row">
          <label class="tec-config-lbl">Edad</label>
          <input
            type="number"
            class="tec-edad-sel"
            :value="answer.answers.edad"
            @input="setEdad($event.target.value)"
            step="1"
            placeholder="Años cumplidos"
          />
        </div>
        <p v-if="is_valid === false && !validEdad" class="tec-warning">
          Debes ingresar la edad
        </p>
      </div>

      <!-- question sections (one per subgroup) -->
      <div
        v-for="(subgroup, gi) in test[1]"
        :key="gi"
        class="tec-section"
      >
        <div class="tec-sec-hdr">
          Ítems {{ gi * 20 + 1 }}–{{ gi * 20 + subgroup.length }}
        </div>
        <div class="tec-qlist">
          <div
            v-for="(question, qi) in subgroup"
            :key="question[0]"
            class="tec-qrow"
            :class="rowState(question)"
          >
            <div class="tec-qnum">{{ gi * 20 + qi + 1 }}</div>
            <div class="tec-seg">
              <button
                v-for="opt in ['1', '2', '3']"
                :key="opt"
                type="button"
                class="tec-seg-btn"
                :class="segBtnClass(question, opt)"
                @click="setAnswer(question[0], opt)"
              >
                {{ opt }}
              </button>
            </div>
            <div class="tec-correct">
              correcta <strong>{{ correctOf(question) }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tec-fab-wrap">
      <button class="tec-fab" @click="send_test">
        <div class="tec-fab-l">
          <div class="tec-fab-icon">📋</div>
          <div>
            <div>Corregir test</div>
            <div class="tec-fab-sub">{{ answeredCount }} de 101 marcadas</div>
          </div>
        </div>
        <div class="tec-fab-arr">→</div>
      </button>
    </div>
  </div>
</template>

<script>
import testService from "../../../../services/testService";
import redpieService from "../../../../services/redpieService";

export default {
  name: "TecalChatbot",
  props: ["test_id", "student_id", "previous_answer", "semester"],
  watch: {
    student_id() {
      this.answer.student_id = this.student_id;
    },
    test_id() {
      this.answer.test = this.test_id;
    },
  },
  data() {
    return {
      answer: { test: this.test_id, answers: {}, student_id: this.student_id },
      test: [
        {
          label: "Edad:",
          type: "select",
          var: "edad",
          options: [
            { value: "3", text: "3.0 - 3.11 años" },
            { value: "4", text: "4.0 - 4.11 años" },
            { value: "5", text: "5.0 - 5.11 años" },
            { value: "6", text: "6.0 - 6.11 años" },
          ],
        },
        [
          [
            ["p1", "2:"], ["p2", "2:"], ["p3", "1:"], ["p4", "3:"], ["p5", "1:"],
            ["p6", "3:"], ["p7", "1:"], ["p8", "1:"], ["p9", "3:"], ["p10", "2:"],
            ["p11", "1:"], ["p12", "1:"], ["p13", "3:"], ["p14", "2:"], ["p15", "1:"],
            ["p16", "3:"], ["p17", "1:"], ["p18", "2:"], ["p19", "3:"], ["p20", "1:"],
          ],
          [
            ["p21", "1:"], ["p22", "3:"], ["p23", "3:"], ["p24", "2:"], ["p25", "3:"],
            ["p26", "3:"], ["p27", "1:"], ["p28", "2:"], ["p29", "1:"], ["p30", "1:"],
            ["p31", "3:"], ["p32", "3:"], ["p33", "1:"], ["p34", "2:"], ["p35", "3:"],
            ["p36", "2:"], ["p37", "1:"], ["p38", "1:"], ["p39", "2:"], ["p40", "3:"],
          ],
          [
            ["p41", "1:"], ["p42", "2:"], ["p43", "2:"], ["p44", "1:"], ["p45", "3:"],
            ["p46", "2:"], ["p47", "1:"], ["p48", "2:"], ["p49", "1:"], ["p50", "1:"],
            ["p51", "3:"], ["p52", "2:"], ["p53", "3:"], ["p54", "2:"], ["p55", "1:"],
            ["p56", "2:"], ["p57", "1:"], ["p58", "1:"], ["p59", "2:"], ["p60", "1:"],
          ],
          [
            ["p61", "3:"], ["p62", "3:"], ["p63", "1:"], ["p64", "1:"], ["p65", "2:"],
            ["p66", "1:"], ["p67", "3:"], ["p68", "1:"], ["p69", "2:"], ["p70", "1:"],
            ["p71", "3:"], ["p72", "2:"], ["p73", "2:"], ["p74", "3:"], ["p75", "3:"],
            ["p76", "1:"], ["p77", "3:"], ["p78", "1:"], ["p79", "2:"], ["p80", "1:"],
          ],
          [
            ["p81", "1:"], ["p82", "3:"], ["p83", "2:"], ["p84", "3:"], ["p85", "2:"],
            ["p86", "2:"], ["p87", "1:"], ["p88", "3:"], ["p89", "1:"], ["p90", "1:"],
            ["p91", "2:"], ["p92", "1:"], ["p93", "1:"], ["p94", "3:"], ["p95", "2:"],
            ["p96", "1:"], ["p97", "3:"], ["p98", "3:"], ["p99", "2:"], ["p100", "2:"],
            ["p101", "1:"],
          ],
        ],
      ],
      required_fields: ["edad"],
      is_valid: null,
    };
  },
  mounted() {
    this.ensureFonts();
    if (this.previous_answer && Object.keys(this.previous_answer).length) {
      for (const [key, value] of Object.entries(this.previous_answer)) {
        this.$set(this.answer.answers, key, value);
      }
    }
  },
  computed: {
    validEdad() {
      // Age is a plain integer (no fixed 3–6 range) — just require a positive
      // whole number so a real entry never blocks the correction.
      const e = parseInt(this.answer.answers.edad, 10);
      return Number.isInteger(e) && e > 0;
    },
    answeredCount() {
      let n = 0;
      this.test[1].forEach((sg) =>
        sg.forEach((q) => {
          if (this.answer.answers[q[0]]) n += 1;
        })
      );
      return n;
    },
    progress() {
      return Math.round((this.answeredCount / 101) * 100);
    },
  },
  methods: {
    // Load the Sora / JetBrains Mono webfonts once (shared with TeprosifChatbot;
    // guarded by id so it's only injected a single time).
    ensureFonts() {
      if (document.getElementById("tep-fonts")) return;
      const link = document.createElement("link");
      link.id = "tep-fonts";
      link.rel = "stylesheet";
      link.href =
        "https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap";
      document.head.appendChild(link);
    },
    setEdad(val) {
      // Store the typed age as-is (string int); undefined when cleared so the
      // warning re-appears.
      this.$set(this.answer.answers, "edad", val === "" ? undefined : val);
    },
    correctOf(question) {
      return question[1].slice(0, -1);
    },
    setAnswer(varName, opt) {
      // Toggle: re-tapping the selected option clears it (so it auto-fills as
      // correct on submit).
      const current = this.answer.answers[varName];
      this.$set(this.answer.answers, varName, current === opt ? "" : opt);
    },
    segBtnClass(question, opt) {
      const v = this.answer.answers[question[0]];
      const correct = this.correctOf(question);
      if (v === opt) return opt === correct ? "sel-ok" : "sel-wrong";
      if (opt === correct) return "is-correct";
      return "";
    },
    rowState(question) {
      const v = this.answer.answers[question[0]];
      if (!v) return "";
      return v === this.correctOf(question) ? "ok" : "wrong";
    },
    getDefaultAnswers() {
      const defaultAnswers = {};
      this.test[1].forEach((subgroup) => {
        subgroup.forEach((question) => {
          defaultAnswers[question[0]] = question[1].slice(0, -1);
        });
      });
      return defaultAnswers;
    },
    checkRequired() {
      const answerKeys = Object.keys(this.answer.answers);
      this.is_valid =
        this.required_fields.every((element) =>
          answerKeys.includes(element)
        ) && this.validEdad;
    },
    send_test() {
      const defaultAnswers = this.getDefaultAnswers();
      Object.keys(defaultAnswers).forEach((key) => {
        if (!this.answer.answers[key]) {
          this.$set(this.answer.answers, key, defaultAnswers[key]);
        }
      });
      this.checkRequired();
      if (this.is_valid) {
        this.answer["semester"] = this.semester;
        testService.send_test(this.answer).then((data) => {
          redpieService
            .assignDocuments({
              test: this.answer.test,
              school: this.$store.state.login.school,
              year: this.$store.state.login.year,
              student_grade: this.answer.student_id,
            })
            .then(() => {
              this.$emit("update-document");
              this.$emit("add-test", data);
            })
            .catch(() => {
              this.$toasted.error("Ha ocurrido al crear el documento");
            });
        });
      }
    },
  },
};
</script>

<style scoped>
.tec-root {
  --y: #f8ac04;
  --yll: #fef7e2;
  --yd: #7a5500;
  --g: #20b2aa;
  --gll: #e2f7f5;
  --gd: #0d6b65;
  --r: #e84756;
  --rll: #fdedef;
  --rd: #a01b27;
  --ink: #111827;
  --mu: #6b7280;
  --mu2: #9ca3af;
  --mu3: #d1d5db;
  --border: rgba(0, 0, 0, 0.08);
  --surf: #fff;
  --bg: #f0f2f6;
  --rad: 14px;
  --rad-sm: 9px;
  --font: "Sora", sans-serif;
  --mono: "JetBrains Mono", monospace;
  --sh: 0 1px 6px rgba(0, 0, 0, 0.07), 0 0 0 0.5px rgba(0, 0, 0, 0.05);
  max-width: 560px;
  margin: 0 auto;
  font-family: var(--font);
  color: var(--ink);
  background: var(--bg);
  border-radius: var(--rad);
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}
.tec-root *,
.tec-root *::before,
.tec-root *::after {
  box-sizing: border-box;
}

/* ── HEADER ── */
.tec-hdr {
  background: var(--ink);
  padding: 13px 16px 11px;
}
.tec-hdr-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.tec-logo-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.08);
  border: 0.5px solid rgba(255, 255, 255, 0.12);
  border-radius: 30px;
  padding: 4px 10px 4px 6px;
}
.tec-logo-gem {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: linear-gradient(135deg, var(--g), var(--y));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.tec-logo-name {
  font-size: 13px;
  font-weight: 600;
  color: white;
  letter-spacing: -0.01em;
}
.tec-hdr-spacer {
  flex: 1;
}
.tec-hdr-step {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 500;
}
.tec-prog-wrap {
  height: 2.5px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
}
.tec-prog-fill {
  height: 100%;
  border-radius: 2px;
  background: linear-gradient(90deg, var(--g), #84cec7);
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ── PHASE BANNER ── */
.tec-phase-banner {
  display: flex;
  align-items: center;
  gap: 7px;
  background: var(--surf);
  border-bottom: 0.5px solid var(--border);
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 500;
  color: var(--mu);
}
.tec-pdot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background: var(--g);
}

/* ── MAIN ── */
.tec-main {
  padding: 12px 14px;
}
.tec-instruc {
  background: var(--surf);
  border-radius: var(--rad-sm);
  border-left: 3px solid var(--g);
  padding: 9px 12px;
  margin-bottom: 12px;
  font-size: 11px;
  color: var(--mu);
  line-height: 1.55;
}
.tec-instruc strong {
  color: var(--ink);
  font-weight: 600;
}

/* ── CONFIG ── */
.tec-config {
  background: var(--surf);
  border-radius: var(--rad);
  border: 0.5px solid var(--border);
  box-shadow: var(--sh);
  padding: 12px;
  margin-bottom: 12px;
}
.tec-config-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tec-config-lbl {
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
  margin: 0;
}
.tec-edad-sel {
  flex: 1;
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--mu3);
  background: white;
  font-family: var(--font);
  font-size: 13px;
  color: var(--ink);
  padding: 0 10px;
  outline: none;
}
.tec-warning {
  color: var(--r);
  font-size: 11px;
  font-weight: 600;
  margin: 6px 0 0;
}

/* ── SECTIONS ── */
.tec-section {
  margin-bottom: 12px;
}
.tec-sec-hdr {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--mu2);
  margin: 0 4px 6px;
}
.tec-qlist {
  background: var(--surf);
  border-radius: var(--rad);
  border: 0.5px solid var(--border);
  box-shadow: var(--sh);
  overflow: hidden;
}

/* ── QUESTION ROW ── */
.tec-qrow {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  border-top: 0.5px solid var(--border);
  border-left: 3px solid transparent;
}
.tec-qrow:first-child {
  border-top: none;
}
.tec-qrow.ok {
  border-left-color: var(--g);
}
.tec-qrow.wrong {
  border-left-color: var(--r);
  background: var(--rll);
}
.tec-qnum {
  width: 28px;
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 700;
  color: var(--mu2);
  flex-shrink: 0;
  text-align: center;
}
.tec-seg {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.tec-seg-btn {
  width: 38px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--mu3);
  background: white;
  font-family: var(--mono);
  font-size: 14px;
  font-weight: 700;
  color: var(--mu2);
  cursor: pointer;
  transition: all 0.12s;
}
/* the correct alternative gets a subtle ring when not yet chosen */
.tec-seg-btn.is-correct {
  border-color: var(--g);
  border-style: dashed;
  color: var(--gd);
}
/* child's response matches the correct alternative */
.tec-seg-btn.sel-ok {
  background: var(--g);
  border-color: var(--g);
  color: white;
}
/* child's response differs from the correct alternative */
.tec-seg-btn.sel-wrong {
  background: var(--r);
  border-color: var(--r);
  color: white;
}
.tec-correct {
  margin-left: auto;
  font-size: 10px;
  color: var(--mu2);
  white-space: nowrap;
  flex-shrink: 0;
}
.tec-correct strong {
  font-family: var(--mono);
  color: var(--gd);
  font-size: 12px;
}

/* ── ACTION ── */
.tec-fab-wrap {
  padding: 10px 14px 16px;
}
.tec-fab {
  width: 100%;
  padding: 14px 18px;
  border-radius: 13px;
  border: none;
  background: var(--ink);
  color: white;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 20px rgba(17, 24, 39, 0.26);
  transition: transform 0.1s;
  letter-spacing: -0.01em;
}
.tec-fab:active {
  transform: scale(0.99);
}
.tec-fab-l {
  display: flex;
  align-items: center;
  gap: 9px;
  text-align: left;
}
.tec-fab-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.13);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}
.tec-fab-sub {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 400;
  margin-top: 1px;
}
.tec-fab-arr {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
</style>
